import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import { useEditingProps, useGetZ3kObject, } from '../../utils/unpack-props';
import { FobButton } from 'z3k-config';
import { Alert, Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { preventDefault, useBox, useCallbacks, usePartial } from 'shared/hooks/utils';
import { reactionsAndGuardZonesOptions } from '../../utils/z3k-selectors';
import { MaterialObjectList } from 'console/device-settings/z3k/components/material-utils/material-object-list';
import { FobButtonComponent, } from 'console/device-settings/z3k/components/radio/fobs/fob-button-433';
import { Z3KSettings, Z3KSettingsEditor, } from 'console/device-settings/z3k/provider/types';
import { SettingFullRow } from '../../material-utils/settings-card/full-row';
import { SettingContainer } from '../../material-utils/settings-card/container';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
const z3k_name = 'fobs';
export const Fob433 = memo(function Fob433() {
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const { service_view, existed_ids, sendCommand } = useContext(Z3KSettings);
    const configBox = useBox(config);
    const [allowAddFobButtons, setAllowFobButtons] = useState(null);
    const boxedAllow = useBox(allowAddFobButtons);
    const onAllowAddFobButtons = useCallback((fob) => {
        sendCommand(fob.id, 'AllowFobButtonsAdd', {
            shouldAllow: boxedAllow.current == null,
        });
        setAllowFobButtons((allow_id) => (allow_id == null ? fob.id : null));
    }, [setAllowFobButtons]);
    useEffect(() => {
        return () => {
            if (boxedAllow.current != null) {
                sendCommand(boxedAllow.current, 'AllowFobButtonsAdd', {
                    shouldAllow: false,
                });
            }
        };
    }, []);
    const onDiscoverClick = useCallbacks([
        preventDefault,
        usePartial(onAllowAddFobButtons, item),
    ]);
    const fob_buttons = useMemo(() => FobButton.get.where(config, ({ fob_id }) => fob_id === id), [config, id]);
    const options = useMemo(() => ({
        reactions_and_guard_zones_options: reactionsAndGuardZonesOptions(config),
    }), [config]);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const is_new_fob = useMemo(() => !existed_ids.has(id), [existed_ids, id]);
    const onDelete = useCallback(({ id }) => {
        replace_config(FobButton.get.removeById(configBox.current, id));
    }, [replace_config]);
    return (_jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "fobs_name", ...nameEditingProps }), service_view && (_jsx(SettingFullRow, { children: _jsxs(Button, { color: allowAddFobButtons !== id ? 'primary' : 'secondary', variant: "contained", disabled: (allowAddFobButtons != null && allowAddFobButtons !== id) ||
                        is_new_fob, onClick: onDiscoverClick, startIcon: _jsx(Add, {}), children: [allowAddFobButtons !== id ? 'Разрешить ' : 'Отменить ', "\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043D\u043E\u043F\u043E\u043A"] }) })), is_new_fob && (_jsx(SettingFullRow, { children: _jsx(Box, { width: "100%", children: _jsx(Alert, { severity: "warning", children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044E \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430, \u0447\u0442\u043E\u0431\u044B \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0438" }) }) })), _jsx(SettingFullRow, { display: "flex", flexDirection: "column", gap: 0, children: _jsx(MaterialObjectList, { name: "\u041A\u043D\u043E\u043F\u043A\u0438 \u0431\u0440\u0435\u043B\u043E\u043A\u0430", object: FobButtonComponent, object_props: options, help_id: "fob_buttons", hideAddButton: true, onDelete: onDelete, value: fob_buttons, onChange: () => { }, validation_warnings_result: null, validation_result: null }) })] }));
});
